import { useMediaQuery } from "@mui/material";
import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import SelectList, { components } from "react-select";
import { AppDispatch } from "../../redux/Store";
import { AddUserInUserManagement } from "../../redux/reducers/UserManagementReducer";

const AddUser = () => {
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const [rolesOptions] = useState([
    { label: "Admin", value: "admin" },
    { label: "Editor", value: "editor" },
    { label: "Viewer", value: "viewer" },
  ]);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data: any) => {
    navigate("/Usertable");
    dispatch(AddUserInUserManagement(data));
  };

  return (
    <div className="h-[80vh]  flex items-center justify-center w-full ">
      <div className="bg-white shadow-2xl rounded-lg px-8 py-4 w-[400px]">
        <h2 className="text-2xl font-semibold text-[#e31c23] mb-6 text-center">
          Add New User
        </h2>
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          {/* First Name */}
          <div className="flex flex-col">
            <label className=" text-sm font-medium text-[#e31c23]">
              First Name
            </label>
            <Controller
              name="firstName"
              control={control}
              rules={{ required: "First name is required" }}
              render={({ field }) => (
                <input
                  {...field}
                  placeholder="Enter first name"
                  className="px-4 font-poppins py-2 mt-1 border border-gray-300 rounded-md focus:outline-none"
                />
              )}
            />
            {errors.firstName && (
              <p className="text-red-500 text-sm mt-1">
                {typeof errors.firstName.message === "string" &&
                  errors.firstName.message}
              </p>
            )}
          </div>

          <div className="flex flex-col">
            <label className="text-sm font-medium text-[#e31c23]">
              Last Name
            </label>
            <Controller
              name="lastName"
              control={control}
              rules={{ required: "Last name is required" }}
              render={({ field }) => (
                <input
                  {...field}
                  placeholder="Enter last name"
                  className=" px-4 font-poppins py-2 mt-1 border border-gray-300 rounded-md focus:outline-none"
                />
              )}
            />
            {errors.lastName && (
              <p className="text-red-500 text-sm mt-1">
                {typeof errors.lastName.message === "string" &&
                  errors.lastName.message}
              </p>
            )}
          </div>

          <div className="flex flex-col">
            <label className=" text-sm font-medium text-[#e31c23]">Email</label>
            <Controller
              name="email"
              control={control}
              rules={{
                required: "Email is required",
                pattern: {
                  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  message: "Enter a valid email address",
                },
              }}
              render={({ field }) => (
                <input
                  {...field}
                  type="email"
                  placeholder="Enter email"
                  className=" px-4 font-poppins py-2 mt-1 border border-gray-300 rounded-md focus:outline-none"
                />
              )}
            />
            {errors.email && (
              <p className="text-red-500 text-sm mt-1">
                {typeof errors.email.message === "string" &&
                  errors.email.message}
              </p>
            )}
          </div>

          <div className="flex flex-col">
            <label className=" text-sm font-medium text-[#e31c23]">
              Select User Role
            </label>
            <Controller
              name="role"
              control={control}
              render={({ field }) => (
                <div className="w-full">
                  <SelectList
                    {...field}
                    options={rolesOptions}
                    isClearable={true}
                    placeholder="Select Title"
                    menuPortalTarget={document.body}
                    //   onInputChange={(inputValue: string) => {
                    //     debounceTitleSearch(inputValue);
                    //   }}
                    onChange={(e) => {
                      field.onChange(e);
                    }}
                    menuPlacement="auto"
                    // isMulti
                    className="border border-solid border-neutral-300 font-poppins rounded-lg w-full lg:text-[14px] sm:text-[10px]"
                    components={{
                      MultiValueContainer: (props) => (
                        <components.MultiValueContainer {...props}>
                          <div className="flex">{props.children}</div>
                        </components.MultiValueContainer>
                      ),
                    }}
                    styles={{
                      container: (provided) => ({
                        ...provided,
                        //   pointerEvents: loadingTitle ? "none" : "auto",
                      }),
                      input: (provided) => ({
                        ...provided,
                        position: "relative",
                        //   pointerEvents: loadingTitle ? "none" : "auto",
                        left: 6,
                        marginRight: "10px",
                        //   caretColor: loadingTitle ? "transparent" : "auto",
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor:
                          state.isSelected || state.isFocused ? "#E6E6E6" : "",
                        color: state.isSelected ? "black" : "black",
                      }),
                      multiValue: (provided) => ({
                        ...provided,
                        height: "30px",
                        display: "flex",
                        alignItems: "center",
                        borderRadius: "6px",
                        minWidth: "none",
                      }),
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 1050, // Ensure dropdown renders above the table
                        position: "absolute", // Prevent dropdown resizing
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)", // Optional shadow
                        // background:"red"
                      }),
                      menuPortal: (provided) => ({
                        ...provided,
                        // zIndex:1050, // Ensures dropdown renders above all elements
                      }),
                      valueContainer: (provided) => ({
                        position: "relative",
                        maxWidth: isSmallScreen ? "52vw" : "20vw",
                        width: "100%",
                        paddingLeft: "6px",
                        display: "flex",
                        alignItems: "center",
                        height: "40px",
                        paddingRight: "8px",
                        overflowX: "auto",
                        overflowY: "hidden",
                        minWidth: "50px",
                        boxSizing: "border-box",
                        // ...(isFirefox && {
                        //   maxWidth: "calc(28vw + 10px)",
                        //   scrollbarWidth: "thin",
                        // }),
                      }),
                      control: (provided) => ({
                        display: "flex",
                        // maxWidth:"37vw",
                        // width:"510px",
                        height: "40px",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                      }),
                      menuList: (provided) => ({
                        // ...provided,
                        maxHeight: "200px",
                        overflow: "hidden",
                        overflowY: "auto",
                      }),
                      clearIndicator: () => ({
                        // pointerEvents: isLoading ? "none" : "auto",
                        marginLeft: "15px",
                        marginTop: "5px",
                        color: "gray",
                      }),
                    }}
                  />
                </div>
              )}
            />
            {errors.roles && (
              <p className="text-red-500 text-sm mt-1">
                {typeof errors.roles.message === "string" &&
                  errors.roles.message}
              </p>
            )}
          </div>

          <div className="flex justify-center mt-6">
            <button
              type="submit"
              className="px-6 w-full cursor-pointer py-2 text-white border-none font-poppins bg-[#E31c23] rounded-md hover:bg-red-600 transition"
            >
              Add User
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddUser;
